import React from "react";
import { Modal, ModalProps, Spin } from "antd";
import { TransferStockPayload } from "api/fulfillment/inventoryChannels";
import { ChannelStockReallocation } from "pages/fulfillment/FulfillmentProductDetailsPage/ChannelStockReallocation";

interface ChannelStockReallocationModalProps extends ModalProps {
  orgId: string;
  productId: string;
  loading: boolean;
  onCancel: () => void;
  onSubmit: (payload: TransferStockPayload) => unknown;
}

export const ChannelStockReallocationModal: React.FC<ChannelStockReallocationModalProps> = ({
  orgId,
  productId,
  onCancel,
  onSubmit,
  ...props
}) => {
  return (
    <Modal
      title="Channel Stock Reallocation"
      footer={false}
      width="max-content"
      closable={true}
      destroyOnClose
      onCancel={onCancel}
      {...props}
    >
      <Spin spinning={props.loading}>
        <ChannelStockReallocation orgId={orgId} productId={productId} onCancel={onCancel} onSubmit={onSubmit} />
      </Spin>
    </Modal>
  );
};
